import React, { useState } from 'react';
import { useAppDispatch } from "@/Hooks/useAppRedux";
import Modal from "antd/lib/modal/Modal";
import { Button, Input, Table } from 'antd';
import { putUserVerify } from '@/Redux/slices/UserVerifySlice';

const UserVerifyModal = ({ 
  isAddNewVerifyUserVisible,
  setIsAddNewVerifyUserVisible,
}: any) => {
  const dispatch = useAppDispatch();
  const [userList, setUserList] = useState([
    {
      key: 1,
      uuid: '',
    },]);

  const columns = [
    {
      title: 'No.',
      dataIndex: 'key',
      key: 'key',
      width: 56,
    },
    {
      title: 'User UUID',
      dataIndex: 'user',
      key: 'user',
      render: (uuid: string, record: any, index: number) => (
        <Input
          allowClear
          onChange={(e: React.ChangeEvent) => {
            const target = e.target as HTMLInputElement;
            updateUserListByKey(index + 1, (oldUserList: any) => ({
              ...oldUserList,
              uuid: target.value,
            }));
          }}
        />
      ),
    },
  ]

  const updateUserListByKey = (key: number, updateFunc: any) => {
    const newData = userList;
    const newIndex = newData.findIndex((e) => e.key === key);
    newData[newIndex] = updateFunc({ ...newData[newIndex] });
    setUserList(newData);
  }

  const addNewVerifiedUserRow = (row: number) => {
    setUserList((prevUserList) => [
      ...prevUserList,
      {
        key: row,
        uuid: '',
      },
    ]);
  } 

  return (
    <Modal
      title="Add New User"
      open={isAddNewVerifyUserVisible}
      onCancel={() => setIsAddNewVerifyUserVisible(false)}
      width={856}
      bodyStyle={{ padding: 0 }}
      footer={null}
    >
      <div className="h-auto bg-white p-6 pb-2">
        <div className="flex justify-end">
          <Button
            type="primary"
            onClick={() => addNewVerifiedUserRow(userList.length + 1)}
          >
            Add New
          </Button>
        </div>
        <Table
          className="mt-4"
          columns={columns}
          dataSource={userList.map((data) => ({
            key: data.key,
            uuid: data.uuid,
          }))}
          pagination={false}
        />
        <div className="flex justify-end pt-6">
          <Button
            type="primary"
            onClick={() => {
              const putUserVerifyData = userList
                .filter((data) => data.uuid !== '')
                .map(({ key, ...data }) => data.uuid);
              dispatch(putUserVerify(putUserVerifyData));
              setIsAddNewVerifyUserVisible(false);
              setUserList([
                {
                  key: 1,
                  uuid: '',
                }
              ]);
            }}
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default UserVerifyModal;